import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_BRAND = { product_name: "SteelForgeAI", tagline: "Document Intelligence. Structural Confidence.", company_name: "", support_email: "", website_url: "", report_footer: "", logo_url: null, favicon_url: null };
const BrandContext = createContext({ brand: DEFAULT_BRAND, logoSrc: "/steelforge-logo.png", refresh: () => {} });

// Platform branding (Super Admin → Branding). Public endpoint, loaded once at boot; drives title, favicon and logos app-wide.
export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(DEFAULT_BRAND);
  const refresh = useCallback(() => axios.get(`${API}/api/branding`).then((r) => setBrand({ ...DEFAULT_BRAND, ...r.data })).catch(() => {}), []);
  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    document.title = brand.product_name || DEFAULT_BRAND.product_name;
    const link = document.querySelector("link[rel='icon']");
    if (link) link.href = brand.favicon_url ? `${API}${brand.favicon_url}` : "/favicon.png";
  }, [brand]);
  const value = useMemo(() => ({ brand, logoSrc: brand.logo_url ? `${API}${brand.logo_url}` : "/steelforge-logo.png", refresh }), [brand, refresh]);
  return <BrandContext.Provider value={value}>{children}</BrandContext.Provider>;
}

export const useBrand = () => useContext(BrandContext);
